import { AfterViewInit, Component } from '@angular/core';
import { Chart } from 'chart.js';
import { debounceTime, distinctUntilChanged, Subject } from 'rxjs';
import { FinancialOverview, Transaction } from 'src/app/Models/Transcations';
import { TransacationServiceService } from 'src/app/Services/transacation-service.service';

@Component({
  selector: 'app-finance-overview',
  templateUrl: './finance-overview.component.html',
  styleUrls: ['./finance-overview.component.css'],
})
export class FinanceOverviewComponent implements AfterViewInit {
  chart: any;
  searchText: string = '';
  selectedTransactionType: string = '';
  TransactionRecords: Transaction[] = [];
username=''
UserId=0
usermail=''
lastname=''
profilePhotoUrls=''
TotalTransactionPages = 0; 
PageNumber = 1; 
  PageSize = 10; 
  dateFilter = '';
  financialOverview: FinancialOverview | null = null;
showChart = false; 


 private searchAllSubject = new Subject<string>();


ngOnInit(): void {
    
 this.getTransactions(); 
   this.getFinancialOverview(); 
  


  this.searchAllSubject.pipe(
       debounceTime(400),            
       distinctUntilChanged()      
     ).subscribe(searchText => {
       this.searchText = searchText;
       this.getTransactions();
     });

}

  ngAfterViewInit() {
    const ctx = document.getElementById('myChart') as HTMLCanvasElement;

    this.chart = new Chart(ctx, {
      type: 'line',
      data: {
        labels: ['Mar 2', 'Mar 9', 'Mar 16', 'Mar 23', 'Mar 30'],
        datasets: [
          {
            label: 'This Month',
            data: [280, 250, 350, 500, 540],
            borderColor: '#3BAA75', 
            backgroundColor: 'rgba(59, 170, 117, 0.05)', 
            tension: 0.4,
            fill: true,
            pointRadius: 0
          },
          {
            label: 'Last Month',
            data: [150, 480, 300, 380, 650],
            borderColor: '#E74C3C', 
            borderDash: [4, 4],
            tension: 0.4,
            fill: false,
            pointRadius: 0
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: {
            beginAtZero: true,
            max: 1000,
            ticks: {
              stepSize: 250,
              callback: value => `$${value}`
            },
            grid: {
              display: false
            }
          },
          x: {
            grid: {
              display: false
            },
            ticks: {
              color: '#666'
            }
          }
        },
        plugins: {
          legend: {
            display: false
          },
          tooltip: {
            mode: 'index',
            intersect: false
          }
        }
      }
    });
  }
constructor(private transactionService: TransacationServiceService) { }

ToggleChart(){
this.showChart = !this.showChart; 
}
onDateFilterChange() {
  this.getTransactions(); 
  this.getFinancialOverview();

}
onSearchChange(search:string) {
  this.searchAllSubject.next(search);
}
onStatusChange() {
  this.getTransactions(); 
    }

onFilterChange(){}

   goToPages(pageNumber: number): void {
    if (pageNumber >= 1 && pageNumber <= this.TotalTransactionPages) {
      this.PageNumber = pageNumber;
 this.getTransactions()
    }
  }

getTransactions() {

    this.transactionService.getAllTransactions(this.searchText, this.PageNumber, this.PageSize, this.selectedTransactionType, this.dateFilter)
      .subscribe(response => {
        this.TransactionRecords = response.items;
        this.TotalTransactionPages = Math.ceil(response.totalCount / this.PageSize);
      });  
}

exportToPdf() {
   
  this.transactionService.downloadFinancialReport(this.searchText,this.selectedTransactionType,this.dateFilter,
    this.PageNumber, this.PageSize,  )
    
    }

  onSizeChanges(newSize: number): void {
    this.PageSize = newSize;
    this.PageNumber = 1;
   this.getTransactions()
  }
getFinancialOverview() {
   
    this.transactionService.getFinancialOverview(this.dateFilter)
      .subscribe(response => {
        
        this.financialOverview = response;

      });
  }


}
